/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallNotificationList } from '../../models/call-notification-list';

export interface GetCallNotificationsByIntervenantCode$Params {

/**
 * Code.
 */
  code: string;
}

export function getCallNotificationsByIntervenantCode(http: HttpClient, rootUrl: string, params: GetCallNotificationsByIntervenantCode$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationList>> {
  const rb = new RequestBuilder(rootUrl, getCallNotificationsByIntervenantCode.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CallNotificationList>;
    })
  );
}

getCallNotificationsByIntervenantCode.PATH = '/notification/call/byIntervenantCode/{code}';
